import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import Pagination from '../layouts/pagination.jsx';
import UpdateStatusComponent from '../../action/updatestatus.jsx';
import EditChannel from './sections/edit.jsx';
import ViewChannel from './sections/view.jsx';

const InactiveChannels = () => {
    const [channels, setChannels] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [channelId, setChannelId] = useState(null);
    const [filterText, setFilterText] = useState('');

    const fetchChannels = async (currentPage) => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/channels?channels=inactive&page=${currentPage + 1}`)
            .then(response => {
                setChannels(response.data.data);
                setPageCount(Math.ceil(response.data.meta.pagination.total / response.data.meta.pagination.per_page));
            })
            .catch(error => {
                console.error("Error fetching channels!", error);
                setChannels([]);
            });
    };

    useEffect(() => {
        fetchChannels(currentPage);
    }, [currentPage]);
    
    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    // Search input handler
    const filteredItems = channels.filter((item) => {
        const matchesName = item.name.toLowerCase().includes(filterText.toLowerCase());
        return matchesName;
    });

    const MAX_LENGTH = 40;
    const truncateText = (text) => {  
        return text.length > MAX_LENGTH ? text.substring(0, MAX_LENGTH) + '...' : text;  
    };
    
    return (
        <>    
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="page-title">Inactive Channels</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Inactive Channels</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4 mb-3">
                        <input className="form-control" type="text"
                            placeholder="Search channel..." aria-label="Search Input"
                            value={filterText} onChange={(event)=>{
                                setFilterText(event.target.value)
                            }} />
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>Channel Name</th>
                                                <th>Description</th>
                                                <th className="text-end">Status &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                </th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredItems.length > 0 ? (
                                                    filteredItems.map((channel) => (
                                                        <tr key={channel.id}>
                                                            <td>{channel.name}</td>
                                                            <td>{channel.description ? truncateText(channel.description) : ''}</td>
                                                            <td className="text-end">
                                                                <UpdateStatusComponent 
                                                                    url = "channel/status"
                                                                    id = {channel.id}
                                                                    fetchData={fetchChannels} 
                                                                    status={channel.status} />
                                                            </td>
                                                            <td className="text-end">
                                                                <div className="dropdown dropdown-action">
                                                                    <Link to="#" className="action-icon dropdown-toggle"
                                                                        data-bs-toggle="dropdown" aria-expanded="false"
                                                                            onClick={() => setChannelId(`${channel.id}`)}>
                                                                            <i className="material-icons">more_vert</i></Link>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                            data-bs-target={`#view_channel_${channel.id}`}>
                                                                                <i className="fa-solid fa-eye m-r-5"></i> View</Link>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="4">No records found</td>
                                                    </tr>
                                                )                                          
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Pagination pageCount={pageCount} handlePageClick={handlePageClick}/>
            </div>
            
            <EditChannel list={fetchChannels} channelId={channelId} />
            <ViewChannel channelId={channelId} />
        </>
    );
}

export default InactiveChannels